// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonNouns = {
  time: "时间",
  operator: "操作人",
  staff: "考务人员",
  candidate: "考生",
  user: "用户",
  paper: "试卷",
  question: "题目",
  exam: "考试",
  attempt: "作答",
  status: "状态",
  role: "角色",
  type: "类型",
  description: "说明",
  codeSnapshot: "代码快照",
  actions: "操作",
} as const;
